import { ApplicationElement, html } from '@effectivastudio/lit-components';

import '@effectivastudio/lit-components/components/avatar/element.js';
import '@effectivastudio/lit-components/components/online_status/element.js';
import '../origin/element.js';

import style from './style.lit.css';

/**
 * Represents a Crossiety user for Public profile.
 *
 * @prop picture - Add picture URL for ```xs-avatar``` (optional)
 * @prop region - region name for the origin component
 * @prop regionImage - region image for the origin component (optional)
 * @prop regionIcon - region icon for the origin component if region image is not defined
 * @prop uid - User id
 * @prop name - Internal property => Taken from slot content to display initials inside avatar
 *
 * @slot default - For user name
 *
 * @cssprop --avatar-size - Avatar size
 * @cssprop --avatar-border-size - Avatar border size
 * @cssprop --status-border-size - Status border size
 * @cssprop --slot-font-size - User name font size
 * @cssprop --padding - Component's padding
 */

export default class ProfileAvatarV2 extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    picture: { type: String },
    region: { type: String },
    regionImage: { type: String },
    regionIcon: { type: String },
    uid: { type: Number },
    name: { state: true },
  };

  handleSlotChange(e) {
    this.name = e.target
      .assignedNodes({ flatten: true })
      .map(node => {
        return node.textContent ? node.textContent : '';
      })
      .join('')
      .trim();
  }

  render() {
    return html`
      <ef-avatar .picture=${this.picture} .name=${this.name} rounded>
      </ef-avatar>
      <ef-online-status .uid=${this.uid}></ef-online-status>
      <div class="wrapper">
        <slot @slotchange=${this.handleSlotChange}></slot>
        <xs-origin
          .name=${this.region}
          .picture=${this.regionImage}
          .icon=${this.regionIcon}>
          ${this.region}
        </xs-origin>
      </div>
    `;
  }
}

customElements.get('xs-profile-avatar-v2') ||
  customElements.define('xs-profile-avatar-v2', ProfileAvatarV2);
